module.exports = __webpack_public_path__ + "img/_PWK2570_-PSedit_.a6d63567.jpeg";